export * from "../../ce/constants/messages";

export const ARTIFACT_SSH_KEY_MANAGER = {
  NO_KEYS_TITLE: "No SSH keys found",
  NO_KEYS_DESCRIPTION:
    "You don't have any SSH keys yet. Create one to securely connect your apps to Git repositories.",
  CREATE_KEY_CTA: "Create SSH Key",
};

// SSH Keys page messages
export const SSH_KEYS_PAGE_TITLE = () => "SSH Keys for Git Artifacts";
export const SSH_KEYS_PAGE_SUBTITLE = () =>
  "Create and share reusable SSH keys to connect applications, packages, and workflows to Git repositories.";

// Create modal
export const CREATE_SSH_KEY_TITLE = () => "Create SSH Key";
export const CREATE_SSH_KEY_NAME_LABEL = () => "Key Name";
export const CREATE_SSH_KEY_NAME_PLACEHOLDER = () =>
  "Enter a name for your SSH key";
export const CREATE_SSH_KEY_TYPE_LABEL = () => "Key Type";
export const CREATE_SSH_KEY_BUTTON = () => "Create Key";
export const CREATE_SSH_KEY_CANCEL = () => "Cancel";

// Delete modal
export const DELETE_SSH_KEY_TITLE = () => "Delete SSH Key";
export const DELETE_SSH_KEY_CONFIRMATION = (keyName: string) =>
  `Are you sure you want to delete "${keyName}"? This action cannot be undone.`;
export const DELETE_SSH_KEY_BUTTON = () => "Delete";
export const DELETE_SSH_KEY_CANCEL = () => "Cancel";

// SSH Key card
export const SSH_KEY_COPY_PUBLIC_KEY = () => "Copy public key";
export const SSH_KEY_PUBLIC_KEY_COPIED = () => "Public key copied to clipboard";
export const SSH_KEY_CREATED_AT = () => "Created";
export const SSH_KEY_OWNED_BY = () => "Owned by";
export const SSH_KEY_SHARED_WITH = () => "Shared with";
export const SSH_KEY_DELETE = () => "Delete";
export const SSH_KEY_NO_KEYS = () => "No SSH keys found";
export const SSH_KEY_NO_KEYS_DESCRIPTION = () =>
  "Create a new SSH key to connect your applications to Git repositories.";
export const SSH_KEY_SHOW_PUBLIC_KEY = () => "Show public key";
export const SSH_KEY_HIDE_PUBLIC_KEY = () => "Hide public key";

// Key types
export const SSH_KEY_TYPE_ECDSA = () => "ECDSA (Recommended)";
export const SSH_KEY_TYPE_RSA = () => "RSA";

// Share modal
export const SHARE_SSH_KEY_TITLE = () => "Share SSH Key";
export const SHARE_SSH_KEY_EMAIL_LABEL = () => "Email Address";
export const SHARE_SSH_KEY_EMAIL_PLACEHOLDER = () =>
  "Enter email to share with";
export const SHARE_SSH_KEY_BUTTON = () => "Save";
export const SHARE_SSH_KEY_CANCEL = () => "Cancel";
export const SHARE_SSH_KEY_SHARED_WITH = () => "Shared with";
export const SHARE_SSH_KEY_NO_SHARES = () => "Not shared with anyone yet";
export const SHARE_SSH_KEY_REMOVE = () => "Remove";
export const SHARE_SSH_KEY_INVALID_EMAIL = () =>
  "Please enter a valid email address";

// Import modal
export const IMPORT_SSH_KEY_TITLE = () => "Import SSH Key";
export const IMPORT_SSH_KEY_DESCRIPTION = () =>
  "Upload a JSON file containing your SSH key data";
export const IMPORT_SSH_KEY_DROP_ZONE = () =>
  "Drop JSON file here or click to browse";
export const IMPORT_SSH_KEY_BUTTON = () => "Import";
export const IMPORT_SSH_KEY_CANCEL = () => "Cancel";
export const IMPORT_SSH_KEY_INVALID_FILE = () => "Invalid SSH key file format";
export const IMPORT_SSH_KEY_SELECT_FILE = () => "Select File";

// Export
export const SSH_KEY_EXPORT = () => "Export";
export const SSH_KEY_EXPORT_SUCCESS = () => "SSH key exported successfully";

// Misc
export const SSH_KEY_BADGE_OWNED = () => "Owned";
export const SSH_KEY_BADGE_SHARED = () => "Shared";
export const SSH_KEY_SHARE = () => "Share";
export const SSH_KEY_IMPORT = () => "Import Key";
